import styled from 'styled-components';
import { THEME } from '../../../../../../themes';
import { ASSETS } from '../../../../../../assets';

export const TimerIcon = styled(ASSETS.FILLED_TIMER)`
  fill: ${THEME.COLORS.SECONDARY};
  width: 17.3px;
  height: 16px;
`;
